import { getUserName } from "./auth";
import baseAxiosPublic from "./config/baseAxiosPublic";

async function getDados(cnpj) {
    const empresas = [
        {
          "cnpj_completo": "01922132.0001/33",
          "nome_fantasia": "",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "19970530",
          "razao_social": "DELIVERY CONSULTORIA, ASSESSORIA, ADMINISTRACAO E CORRETAGEM DE SEGUROS S/C LTDA",
          "capital_social": "0,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Simples Limitada",
          "cnae_fiscal_principal": "Corretores e agentes de seguros, de planos de previdencia complementar e de saude",
          "cnae_fiscal_secundaria": null,
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "WALTER RIBEIRO DA SILVA",
          "qualificacao_socio": "Socio-Administrador",
          "cpf_cnpj_socio": "***679738**",
          "tipo_logradouro": "RUA",
          "logradouro": "JAIMINHO",
          "numero": "200",
          "complemento": "1 ANDAR / SALA 11",
          "bairro": "VILA PROGRESSO",
          "cep": "07095150",
          "municipio": "GUARULHOS",
          "uf": "SP"
        },
        {
          "cnpj_completo": "02220843.0001/29",
          "nome_fantasia": "",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "19971023",
          "razao_social": "MELINDA & JULIUS COMERCIO DE ALIMENTOS LTDA",
          "capital_social": "10000,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Comercio varejista de mercadorias em geral, com predominancia de produtos alimenticios - minimercados, mercearias e armazens",
          "cnae_fiscal_secundaria": "Comercio varejista de jornais e revistas",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "HOSANNA MAKIKO NISHIDA KATO",
          "qualificacao_socio": "Socio-Administrador",
          "cpf_cnpj_socio": "***453928**",
          "tipo_logradouro": "RUA",
          "logradouro": "DOM ARMANDO LOMBARDI",
          "numero": "511",
          "complemento": "",
          "bairro": "VILA PROGREDIOR",
          "cep": "05616011",
          "municipio": "SAO PAULO",
          "uf": "SP"
        },
        {
          "cnpj_completo": "02825971.0003/68",
          "nome_fantasia": "RENOAIR ENERGIAS RENOVAVEIS",
          "identificador_matriz_filial": "Filial",
          "data_incio_atividade": "20240823",
          "razao_social": "RENOAIR ENERGIAS RENOVAVEIS DO BRASIL LTDA",
          "capital_social": "1500000,00",
          "porte_empresa": "Demais",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Instalacao de maquinas e equipamentos industriais",
          "cnae_fiscal_secundaria": "Manutencao e reparacao de aparelhos e instrumentos de medida, teste e controle",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "MARCIO FERREIRA MARQUES",
          "qualificacao_socio": "Socio-Administrador",
          "cpf_cnpj_socio": "***653399**",
          "tipo_logradouro": "RUA",
          "logradouro": "MAESTRO BANDEIRA",
          "numero": "493",
          "complemento": "",
          "bairro": "JARDIM",
          "cep": "96055650",
          "municipio": "PELOTAS",
          "uf": "RS"
        },
        {
          "cnpj_completo": "04483953.0001/09",
          "nome_fantasia": "DELLA VIA TRANSPORTES",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20010531",
          "razao_social": "DELLA VIA TRANSPORTES LTDA",
          "capital_social": "0,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Transporte rodoviario de carga, exceto produtos perigosos e mudancas, intermunicipal, interestadual e internacional",
          "cnae_fiscal_secundaria": null,
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "AMILTON FERNANDO DA SILVA BRZEZINSKI",
          "qualificacao_socio": "Socio-Administrador",
          "cpf_cnpj_socio": "***465720**",
          "tipo_logradouro": "AVENIDA",
          "logradouro": "MARIO RIBEIRO",
          "numero": "483",
          "complemento": "",
          "bairro": "CENTRO",
          "cep": "92990000",
          "municipio": "ELDORADO DO SUL",
          "uf": "RS"
        },
        {
          "cnpj_completo": "07600682.0001/12",
          "nome_fantasia": "PEROLA DIGITACOES",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20050912",
          "razao_social": "PEROLA DIGITACOES LTDA",
          "capital_social": "10000,00",
          "porte_empresa": "Empresa de Pequeno Porte",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Suporte tecnico, manutencao e outros servicos em tecnologia da informacao",
          "cnae_fiscal_secundaria": "Preparacao de documentos e servicos especializados de apoio administrativo nao especificados anteriormente",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "APARECIDA MENDES DO AMARAL",
          "qualificacao_socio": "Socio",
          "cpf_cnpj_socio": "***524708**",
          "tipo_logradouro": "RUA",
          "logradouro": "DO COURO",
          "numero": "702",
          "complemento": "SB",
          "bairro": "JARDIM PEROLA",
          "cep": "13454180",
          "municipio": "SANTA BARBARA D'OESTE",
          "uf": "SP"
        },
        {
          "cnpj_completo": "07741444.0001/27",
          "nome_fantasia": "GRUPO PET",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20051018",
          "razao_social": "COMERCIAL CCL DE COSMETICOS LTDA",
          "capital_social": "10500,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Comercio varejista de animais vivos e de artigos e alimentos para animais de estimacao",
          "cnae_fiscal_secundaria": "Comercio varejista de produtos alimenticios em geral ou especializado em produtos alimenticios nao especificados anteriormente",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "LUIS FELIPE COROA PINHEIRO",
          "qualificacao_socio": "Socio",
          "cpf_cnpj_socio": "***103408**",
          "tipo_logradouro": "ESTRADA",
          "logradouro": "DAS ACACIAS",
          "numero": "1067",
          "complemento": "",
          "bairro": "PARQUE ROSEIRA",
          "cep": "06385023",
          "municipio": "CARAPICUIBA",
          "uf": "SP"
        },
        {
          "cnpj_completo": "07767177.0001/67",
          "nome_fantasia": "MB VEICULOS",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20051129",
          "razao_social": "MB VEICULOS ARACATUBA LTDA",
          "capital_social": "1000,00",
          "porte_empresa": "Empresa de Pequeno Porte",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Atividades de intermediacao e agenciamento de servicos e negocios em geral, exceto imobiliarios",
          "cnae_fiscal_secundaria": "Comercio a varejo de automoveis, camionetas e utilitarios novos",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "MARCO ANTONIO BARRETO DOS SANTOS",
          "qualificacao_socio": "Socio-Administrador",
          "cpf_cnpj_socio": "***044138**",
          "tipo_logradouro": "RUA",
          "logradouro": "MARCONI",
          "numero": "51",
          "complemento": "APT   64",
          "bairro": "CENTRO",
          "cep": "16010610",
          "municipio": "ARACATUBA",
          "uf": "SP"
        },
        {
          "cnpj_completo": "08591280.0003/23",
          "nome_fantasia": "",
          "identificador_matriz_filial": "Filial",
          "data_incio_atividade": "20070314",
          "razao_social": "IVANA APARECIDA SOARES BAASZK E OUTROS",
          "capital_social": "0,00",
          "porte_empresa": "Demais",
          "natureza_juridica": "Produtor Rural (Pessoa Fisica)",
          "cnae_fiscal_principal": "Cultivo de laranja",
          "cnae_fiscal_secundaria": null,
          "qualificacao": "Produtor Rural",
          "nome_socio_razao_social": "KELLY CRISTINA BAASZK DELGADO",
          "qualificacao_socio": "Produtor Rural",
          "cpf_cnpj_socio": "***583688**",
          "tipo_logradouro": "CHACARA",
          "logradouro": "SANTA LUZIA",
          "numero": "S/N",
          "complemento": "",
          "bairro": "BARBOSAO",
          "cep": "13480970",
          "municipio": "LIMEIRA",
          "uf": "SP"
        },
        {
          "cnpj_completo": "08760494.0001/14",
          "nome_fantasia": "LIDERANCA",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20070412",
          "razao_social": "LIDERANCA CORRETORA DE SEGUROS LTDA",
          "capital_social": "20000,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Empresaria Limitada",
          "cnae_fiscal_principal": "Corretores e agentes de seguros, de planos de previdencia complementar e de saude",
          "cnae_fiscal_secundaria": "Promocao de vendas",
          "qualificacao": "Socio-Administrador",
          "nome_socio_razao_social": "JOSEILTON ARAUJO DOS SANTOS",
          "qualificacao_socio": "Socio",
          "cpf_cnpj_socio": "***175724**",
          "tipo_logradouro": "RUA",
          "logradouro": "AGERSON DANTAS",
          "numero": "148",
          "complemento": "",
          "bairro": "CENTRO",
          "cep": "57020310",
          "municipio": "MACEIO",
          "uf": "AL"
        },
        {
          "cnpj_completo": "08991829.0001/05",
          "nome_fantasia": "PATRIMONIAL NOVA ESPERANCA",
          "identificador_matriz_filial": "Matriz",
          "data_incio_atividade": "20070815",
          "razao_social": "PATRIMONIAL NOVA ESPERANCA SOCIEDADE CIVIL LTDA",
          "capital_social": "750000,00",
          "porte_empresa": "Micro Empresa",
          "natureza_juridica": "Sociedade Simples Limitada",
          "cnae_fiscal_principal": "Servicos de agronomia e de consultoria as atividades agricolas e pecuarias",
          "cnae_fiscal_secundaria": "Criacao de bovinos para corte",
          "qualificacao": "Administrador",
          "nome_socio_razao_social": "SONAYRA KARINE MATOS CAMPOS",
          "qualificacao_socio": "Socio",
          "cpf_cnpj_socio": "***713675**",
          "tipo_logradouro": "FAZENDA",
          "logradouro": "BOA ESPERANCA",
          "numero": "S/N",
          "complemento": "KM    78 BR 242",
          "bairro": "ZONA RURAL",
          "cep": "46880000",
          "municipio": "ITABERABA",
          "uf": "BA"
        }
      ]
  
      return new Promise(resolve => {
        setTimeout(() => {
          const resultado = empresas.find(item => item.cnpj_completo === cnpj) || null;
          resolve(resultado);
        }, 1500);
      });
  }  

export {
    getDados
}